/**
 * Unified add-to-cart buttons: header cart icon + consistent primary styling.
 */
(function () {
  let cartIconMarkup = null;

  function loadCartIcon() {
    if (cartIconMarkup) return cartIconMarkup;

    const template = document.getElementById('sb-cart-icon-template');
    if (!template) return null;

    const svg = template.content?.querySelector('svg') || template.querySelector('svg');
    if (!svg) return null;

    cartIconMarkup = svg.outerHTML.replace('<svg', '<svg class="icon icon-cart"');
    return cartIconMarkup;
  }

  function enhanceButton(button) {
    if (!button || button.classList.contains('sb-cta--enhanced')) return;

    const labelSpan =
      button.querySelector('span:not(.sb-cta__icon):not(.loading__spinner)') || button;
    const labelText = (labelSpan.textContent || '').trim();
    const isSoldOut =
      button.hasAttribute('data-sb-sold-out') ||
      button.disabled ||
      labelText.match(/uitverkocht|sold out|unavailable|niet beschikbaar|épuisé|ausverkauft|agotado|rupture de stock/i);

    button.classList.add('sb-cta', 'sb-cta--enhanced', 'button--primary');
    button.classList.remove('button--secondary');

    if (!isSoldOut && !button.querySelector('.sb-cta__icon')) {
      const svg = loadCartIcon();
      if (svg) {
        const icon = document.createElement('span');
        icon.className = 'sb-cta__icon svg-wrapper';
        icon.innerHTML = svg;
        button.insertBefore(icon, labelSpan);
      }
    }
  }

  function enhanceAll() {
    document
      .querySelectorAll('.product-form__submit, .quick-add__submit, .sb-mobile-sticky-atc__submit')
      .forEach(enhanceButton);
  }

  function observeRecommendations() {
    document.querySelectorAll('product-recommendations').forEach((el) => {
      if (el.dataset.sbCtaObserved) return;
      el.dataset.sbCtaObserved = '1';
      const observer = new MutationObserver(() => enhanceAll());
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  function init() {
    enhanceAll();
    observeRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    enhanceAll();
    observeRecommendations();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => enhanceAll());
  }
})();
